<div class="table-toolbar">
    <div class="table-toolbar__main">
        <div class="table-toolbar__left">
            <ng-content select="[leftActions]"></ng-content>
        </div>
        <div class="table-toolbar__right">
            <app-searchbar
                class="table-toolbar__search"
                [placeholder]="placeholder()"
                [disableEnterKey]="disableEnterSearch()"
                [rightIcon]="true"
                (searchValueChange)="onSearchValueChange($event)"
                (searchTriggered)="onSearchButtonClick()">
            </app-searchbar>
            <!-- Desktop Actions -->
            <div class="table-toolbar__actions-desktop">
                <ng-content select="[rightActions]"></ng-content>

                <!-- Export and Bulk Delete buttons temporarily hidden -->
                @for (
                    button of buttons().filter(
                        (b) =>
                            !b.buttonName.toLowerCase().includes('export') &&
                            !b.buttonName.toLowerCase().includes('delete')
                    );
                    track button.buttonName
                ) {
                    <ntv-button
                        [variant]="button.variant || 'secondary'"
                        [color]="button.color || ''"
                        [customColor]="button.customColor || ''"
                        [disabled]="button.disabled !== undefined && button.disabled"
                        size="xl"
                        rounded="md"
                        (click)="onActionClick(button.buttonName)">
                        <div
                            class="table-toolbar__btn"
                            [class.text-primary-300]="
                                !button.textColor && button.variant === 'secondary'
                            "
                            [class.text-white]="
                                button.textColor === 'white' || button.color === 'custom'
                            "
                            [style.color]="button.textColor">
                            @if (buttonIconPlacement() === 'left') {
                                <svg
                                    width="14"
                                    height="14"
                                    [style.width]="button.iconSize?.width"
                                    [style.height]="button.iconSize?.height">
                                    <use
                                        [attr.xlink:href]="
                                            'assets/icons/icons-sprite.svg#' + button.icon
                                        "></use>
                                </svg>
                            }
                            <span class="text-sm btn--text">{{ button.buttonName }}</span>
                            @if (buttonIconPlacement() === 'right') {
                                <svg
                                    width="14"
                                    height="14"
                                    [style.width]="button.iconSize?.width"
                                    [style.height]="button.iconSize?.height">
                                    <use
                                        [attr.xlink:href]="
                                            'assets/icons/icons-sprite.svg#' + button.icon
                                        "></use>
                                </svg>
                            }
                        </div>
                    </ntv-button>
                }
                <ng-content select="[rightActionsEnd]"></ng-content>
            </div>

            <!-- Mobile Actions (FAB + Popover) -->
            <div class="table-toolbar__actions-mobile">
                <ntv-button type="fab" variant="accent" (click)="moreActionsPopover.toggle($event)">
                    <svg width="20" height="20" color="white">
                        <use xlink:href="assets/icons/icons-sprite.svg#ellipsis"></use>
                    </svg>
                </ntv-button>

                <ntv-popover #moreActionsPopover placement="bottom-end" [offset]="10">
                    <div class="table-toolbar__popover-content">
                        <div class="table-toolbar__popover-buttons">
                            <!-- Export and Bulk Delete buttons temporarily hidden -->
                            @for (
                                button of buttons().filter(
                                    (b) =>
                                        !b.buttonName.toLowerCase().includes('export') &&
                                        !b.buttonName.toLowerCase().includes('delete')
                                );
                                track button.buttonName
                            ) {
                                <div
                                    class="table-toolbar__popover-item"
                                    (click)="
                                        onActionClick(button.buttonName); moreActionsPopover.hide()
                                    ">
                                    <svg width="16" height="16" [style.color]="button.textColor">
                                        <use
                                            [attr.xlink:href]="
                                                'assets/icons/icons-sprite.svg#' + button.icon
                                            "></use>
                                    </svg>
                                    <span>{{ button.buttonName }}</span>
                                </div>
                            }
                        </div>
                    </div>
                </ntv-popover>
            </div>
        </div>
    </div>

    @if ((filterDropdown()?.activeFilterChips()?.length ?? 0) > 0 || additionalChips().length > 0) {
        <div class="table-toolbar__active-filters">
            @for (
                chip of filterDropdown()?.activeFilterChips() ?? [];
                track chip.option.id || chip.label
            ) {
                <span class="filter-chip">
                    @if (chip.groupLabel) {
                        <span class="filter-chip__group">{{ chip.groupLabel }}:</span>
                    }
                    <span>{{ chip.label }}</span>
                    <button
                        class="filter-chip__remove"
                        type="button"
                        (click)="filterDropdown()!.onRemoveFilter(chip.option)">
                        &times;
                    </button>
                </span>
            }
            @for (chip of additionalChips(); track chip.label) {
                <span class="filter-chip">
                    @if (chip.groupLabel) {
                        <span class="filter-chip__group">{{ chip.groupLabel }}:</span>
                    }
                    <span>{{ chip.label }}</span>
                    <button class="filter-chip__remove" type="button" (click)="chip.onRemove()">
                        &times;
                    </button>
                </span>
            }
            <button class="filter-chip__clear-all" type="button" (click)="onClearAllChips()">
                Clear all
            </button>
        </div>
    }
</div>
